import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserAvatar, { Props as UserAvatarProps } from './UserAvatar';
import UserAvatarPopover from '../AvatarPopover';
import { ResourceType } from '../../types/resource';
import { isGroup as getIsGroup } from '../helpers';
import {
  BiContextAllowedProps,
  BiData,
  UserNameHoverToOpenBiEvent,
} from '@wix/da-bi/pkg/events';

export interface Props extends UserAvatarProps {
  withTooltip?: boolean;
  relatedItemBiData?: BiContextAllowedProps;
}

export const UserAvatarWithPopover: React.FC<Props> = ({
  withTooltip,
  user,
  className,
  biData,
  relatedItemBiData,
  ...props
}) => {
  const isMobile = useContext(MobileContext);
  const isGroup = user && getIsGroup(user);
  const shouldRenderTooltip = withTooltip && !isMobile && !isGroup;

  if (!shouldRenderTooltip || !user) {
    return (
      <UserAvatar
        user={user}
        className={className}
        biData={biData}
        {...props}
      />
    );
  }

  return (
    <UserAvatarPopover
      username={user.username}
      className={className}
      relatedItemBiData={relatedItemBiData}
      biData={BiData<UserNameHoverToOpenBiEvent>({
        ...(biData as UserNameHoverToOpenBiEvent),
        itemid: user.userId,
        typeid: isGroup ? ResourceType.GROUP : ResourceType.USER,
        evid: 107,
      })}
    >
      <UserAvatar user={user} biData={biData} {...props} />
    </UserAvatarPopover>
  );
};
UserAvatarWithPopover.displayName = 'UserAvatarWithPopover';

export default UserAvatarWithPopover;
